import React, { useEffect, useRef, useState } from "react";
import {
  BackButton,
  Box,
  ButtonStyled,
  LabelStyled,
  SeparatorBorder,
  SpanStyled,
  SubHeadingStyled,
  ThemeLoader,
} from "../../../components/styled/Elements";
import { useNavigate } from "react-router-dom";
import { AddCabinetWrapper } from "./styled";
import { useTranslation } from "react-i18next";
import { ContentWrapper } from "../../../components/styled/styled";
import ValidatedInput from "../../../components/common/inputFields/ValidatedInput";
import { useForm } from "react-hook-form";
import {
  DateIcon,
  Plus,
  SingleProfile,
  TimeSquare,
} from "../../../components/styled/AllImages";
import Breadcrumbs from "../../../components/admin/Breadcrumbs/Breadcrumbs";
import { Form } from "react-bootstrap";
import CabinetsApi from "../../../services/api/cabinetsApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useUser } from "../../../context/userContext";
import TimeOnlyPicker from "../../../components/common/inputFields/TimePicker";
import DatePickerRightIcon from "../../../components/common/inputFields/DatePickerRightIcon";
import { toUTCISOStringFromDateTime } from "../../../utils";
import AddMultipleUsersBranchDep from "./components/AddMultiUsersBranchDep";

const AddTemporaryCabinet = () => {
  const { user } = useUser();
  const { usersList, branchesDeps, hqBranchesList } = useSelector(
    (state) => state.helper
  );
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const prevCabinetType = useRef(null);

  const filteredUsers = usersList?.filter(
    (usr) => usr?.user_detail?.department_id == user?.department?.id
  );

  const [selectedIds, setSelectedIds] = useState(null);
  const [userSelections, setUserSelections] = useState({
    branch_ids: [],
    department_ids: [],
    user_ids: [],
  });
  const [dataLoading, setDataLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [radioOptions, setRadioOptions] = useState([]);
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    resetField,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      selected_ids: selectedIds,
    },
  });
  const cabinetType = 1;

  const checkSelectedValueID = watch("setting_id");

  const fromDate = watch("from_date");
  const tillDate = watch("till_date");
  const fromTime = watch("from_time");

  const filterTimeFrom = (time) => {
    if (!fromDate) return false;
    const now = new Date();
    const selectedDate = new Date(fromDate);
    const isToday =
      selectedDate.getDate() === now.getDate() &&
      selectedDate.getMonth() === now.getMonth() &&
      selectedDate.getFullYear() === now.getFullYear();

    if (isToday) {
      return time.getTime() >= now.getTime();
    }

    return true;
  };

  const filterTimeTill = (time) => {
    if (!tillDate || !fromDate) return false;

    const selectedFromDate = new Date(fromDate);
    const selectedTillDate = new Date(tillDate);
    const selectedFromTime = new Date(fromTime);

    const isSameDate =
      selectedFromDate.getDate() === selectedTillDate.getDate() &&
      selectedFromDate.getMonth() === selectedTillDate.getMonth() &&
      selectedFromDate.getFullYear() === selectedTillDate.getFullYear();

    // If from_date === till_date, disable times earlier than from_time
    if (isSameDate) {
      return time.getTime() >= selectedFromTime.getTime();
    }

    // If till_date is today, only allow future times from now
    const now = new Date();
    const isTillToday =
      selectedTillDate.getDate() === now.getDate() &&
      selectedTillDate.getMonth() === now.getMonth() &&
      selectedTillDate.getFullYear() === now.getFullYear();

    if (isTillToday) {
      return time.getTime() >= now.getTime();
    }

    return true;
  };

  const isDisabledFrom = !fromDate;
  const isDisabledTill = !tillDate;

  const getEndOfDay = (date) => {
    const end = new Date(date);
    end.setHours(23, 59, 59, 999);
    return end;
  };
  const getStartOfDay = (date) => {
    const start = new Date(date);
    start.setHours(0, 0, 0, 0);
    return start;
  };

  const now = new Date();
  const minTimeTill = (() => {
    if (!tillDate || !fromDate || !fromTime) return now;

    const selectedTill = new Date(tillDate);
    const selectedFrom = new Date(fromDate);
    const selectedFromTime = new Date(fromTime);

    const isSameDate =
      selectedFrom.getDate() === selectedTill.getDate() &&
      selectedFrom.getMonth() === selectedTill.getMonth() &&
      selectedFrom.getFullYear() === selectedTill.getFullYear();

    if (isSameDate) {
      return selectedFromTime;
    }

    const isToday =
      selectedTill.getDate() === now.getDate() &&
      selectedTill.getMonth() === now.getMonth() &&
      selectedTill.getFullYear() === now.getFullYear();

    return isToday ? now : getStartOfDay(selectedTill);
  })();

  const maxTime = tillDate ? getEndOfDay(new Date(tillDate)) : getEndOfDay(now);

  const isFromDateValid = !!fromDate && !isNaN(new Date(fromDate).getTime());
  const isFromTimeValid = !!fromTime && !isNaN(new Date(fromTime).getTime());

  const isTillDisabled = !(isFromDateValid && isFromTimeValid);

  const handleSingleSelect = (id) => {
    if (id) {
      setSelectedIds([id]);
    } else {
      setSelectedIds([]);
    }
  };
  const validateSelection = (value) => {
    if (
      [4, 5, 8, 9].includes(Number(checkSelectedValueID)) &&
      (!value || value.length === 0)
    ) {
      return t("Please_select_user");
    }
    if ([6, 7].includes(Number(checkSelectedValueID)) && !value) {
      return t("Please_select_department");
    }
    return true;
  };
  const getRadioData = async () => {
    try {
      setDataLoading(true);
      const response = await CabinetsApi.addCabinetRadio();
      if (response?.data?.length > 1) {
        const filteredOptions = response.data.slice(1);
        setRadioOptions([
          ...filteredOptions.map((option) => {
            if (option.id == 7 || option.id == 8) {
              return { ...option, description: "" };
            } else if (option.id == 6) {
              return {
                ...option,
                description: t("only_open_to_one_department_description"),
              };
            } else if (
              option.id == 2 ||
              option.id == 3 ||
              option.id == 4 ||
              option.id == 5
            ) {
              return {
                ...option,
                description: t("cabinet_settings_description"),
              };
            }
            return option;
          }),
        ]);
      }
    } catch (error) {
    } finally {
      setDataLoading(false);
    }
  };
  useEffect(() => {
    getRadioData();
  }, [language]);

  const onSubmit = async (formData) => {
    const {
      from_date,
      from_time,
      till_date,
      till_time,
      cabinet_type,
      ...restFormData
    } = formData;

    if (userSelections?.user_ids) setSelectedIds(userSelections?.user_ids);
    const updatedData = {
      ...restFormData,
      action: "create",
      selected_ids: selectedIds,
      from_branches: userSelections.branch_ids,
      from_departments: userSelections.department_ids,
      is_temporary: cabinetType,
      time_limit_start:
        parseInt(cabinetType) === 1
          ? toUTCISOStringFromDateTime(formData?.from_date, formData?.from_time)
          : null,

      time_limit_end:
        parseInt(cabinetType) === 1
          ? toUTCISOStringFromDateTime(formData?.till_date, formData?.till_time)
          : null,
    };

    try {
      setLoading(true);
      const response = await CabinetsApi.createCabinet(updatedData);
      if (response.code === 200) {
        toast.success(`${t("Cabinet")} ${t("Created_Successfully")}`);
        reset();
        navigate("/temporary-cabinets");
      }
      if (response.code === 100 || response.code === 204) {
        toast.error(response.message);
      }
      if (response?.code === 429) {
        toast.error(response?.message);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const currentType = parseInt(cabinetType);

    if (
      (prevCabinetType.current === 0 && currentType === 1) ||
      (prevCabinetType.current === 1 && currentType === 0)
    ) {
      if (currentType === 0) {
        resetField("date");
        resetField("from_time");
        resetField("till_time");
      } else if (currentType === 1) {
        resetField("setting_id");
        resetField("selected_ids");
      }
    }

    if (currentType === 0 || currentType === 1) {
      prevCabinetType.current = currentType;
    }
  }, [cabinetType, resetField]);

  return (
    <AddCabinetWrapper>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box className="content-head">
          <Box className="d-flex align-items-center flex-wrap flex-sm-nowrap gap-3 gap-md-5">
            <BackButton
              label={t("add_temporary_cabinet")}
              onClick={() => navigate("/temporary-cabinets")}
            />
            <Breadcrumbs />
          </Box>
        </Box>
        <ContentWrapper>
          {dataLoading ? (
            <ThemeLoader />
          ) : (
            <>
              <Box>
                <ValidatedInput
                  name="cabinet_name"
                  type="input"
                  fieldType="text"
                  placeholder={"cabinet_name"}
                  label="cabinet_name"
                  staric={true}
                  register={register}
                  errors={errors}
                  validationRules={{
                    required: true,
                  }}
                  className={"border-0"}
                />
                <ValidatedInput
                  name="description"
                  label="Description"
                  type="textarea"
                  placeholder={"Description"}
                  errors={errors}
                  register={register}
                  validationRules={{
                    required: false,
                  }}
                />
              </Box>

              <Box>
                <SubHeadingStyled
                  size="15px"
                  weight={700}
                  color={"var(--text)"}
                  className="px-4 pt-4 pb-0"
                >
                  {t("valid_from")}
                </SubHeadingStyled>
                <Box className="info-item gap-2 d-flex align-items-center py-4 px-4 px-lg-4 w-100 formEleContainer me-2">
                  <p className="date-label">{t("date")}</p>
                  <Box className="w-100">
                    <DatePickerRightIcon
                      name={"from_date"}
                      type={"input"}
                      placeholder={t("date")}
                      icon={DateIcon}
                      control={control}
                      errors={errors}
                      rules={{ required: true }}
                      yearDropdown={true}
                      monthDropdown={true}
                      // maxDate={new Date()}
                      minDate={new Date()}
                      bg="var(--bgSecondary)"
                      icon_position="right"
                    />
                  </Box>
                </Box>

                <Box>
                  <TimeOnlyPicker
                    name="from_time"
                    control={control}
                    label="Pick Time"
                    rules={{ required: true }}
                    bg="var(--bgSecondary)"
                    icon={TimeSquare}
                    errors={errors}
                    // minTime={minFromTime}
                    fromDate={fromDate}
                    isDisabledFrom={isDisabledFrom}
                    filterTimeFrom={filterTimeFrom}
                  />
                </Box>
              </Box>
              <SeparatorBorder className="mt-2" />
              <Box>
                <SubHeadingStyled
                  size="15px"
                  weight={700}
                  color={"var(--text)"}
                  className="px-4 pt-4 pb-0"
                >
                  {t("valid_till")}
                </SubHeadingStyled>
                <Box className="info-item gap-2 d-flex align-items-center py-4 px-4 px-lg-4 w-100 formEleContainer me-2">
                  <p className="date-label">{t("date")}</p>
                  <Box className="w-100">
                    <DatePickerRightIcon
                      name={"till_date"}
                      type={"input"}
                      placeholder={t("date")}
                      icon={DateIcon}
                      control={control}
                      errors={errors}
                      rules={{ required: true }}
                      yearDropdown={true}
                      monthDropdown={true}
                      minDate={fromDate}
                      bg="var(--bgSecondary)"
                      icon_position="right"
                      disabled={isTillDisabled}
                    />
                  </Box>
                </Box>

                <Box>
                  <TimeOnlyPicker
                    name="till_time"
                    control={control}
                    label="Pick Time"
                    rules={{ required: true }}
                    bg="var(--bgSecondary)"
                    icon={TimeSquare}
                    errors={errors}
                    //  minTime={minTillTime}
                    tillDate={tillDate}
                    isDisabledTill={isDisabledTill}
                    filterTimeTill={filterTimeTill}
                    minTime={minTimeTill}
                    maxTime={maxTime}
                    disabled={isDisabledTill || isTillDisabled}
                  />
                </Box>
              </Box>

              <SeparatorBorder className="mt-2" />
              <Box>
                <Box className="d-flex justify-content-end">
                  <Box className="p-4 d-flex gap-3">
                    <ButtonStyled
                      label={t("Cancel")}
                      bg={"var(--bgSecondary)"}
                      color={"var(--text2)"}
                      type="button"
                      onClick={() => navigate("/temporary-cabinets")}
                    />
                    <ButtonStyled
                      label={t("Create")}
                      type="submit"
                      isLoading={loading}
                    />
                  </Box>
                </Box>
              </Box>
            </>
          )}
        </ContentWrapper>
      </Form>
    </AddCabinetWrapper>
  );
};

export default AddTemporaryCabinet;
